<template>
  <div class="frames-css">
    <!-- <header-area></header-area> -->
     <div class="bg-gradient-gray">
        <framesVideo></framesVideo>
        <!-- <footerArea></footerArea> -->
     </div>
 </div>
</template>

<script>
import bannerSearch from '../home/bannerSearch.vue'
import { EventBus } from '@/main.js'
import framesVideo from './framesVideo'
import courseCards from '../home/courseCards'
import footerArea from '../common/footerArea'
export default {
  name: 'wishlist',
  components: {
    bannerSearch,
    courseCards,
    framesVideo,
    footerArea
  },
  data () {
    return {
    }
  },
  mounted () {
    EventBus.$emit('showNav', false)
  }
}
</script>
<style lang="scss">
.frames-css{
  .bg-gradient-gray{
      background: linear-gradient(to bottom, #fafafa 95%,#ffffff 100%); 
  }
}
</style>




// WEBPACK FOOTER //
// src/components/contentViewer/frames.vue?6787f1b6